import styled from 'styled-components';

import { path } from 'utils/media';

export const AvatarImage = styled.img.attrs({
  size: props => props.size || 100,
  src: props => (props.image ?
    path(props.image, 'avatarTripCard') :
    require('images/default-img.png')
  )
})`
  display: block;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  min-height: ${props => props.size}px;
  border-radius: 50%;
`;

export default {};



// WEBPACK FOOTER //
// ./src/components/Core/Images.js